export function CheckCircle(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.2512 4.47347C12.3902 4.09254 12.2208 3.66072 11.848 3.48018C11.4504 3.2876 10.9719 3.45383 10.7793 3.85148L7.42906 10.7691L7.39864 10.8209C7.2965 10.9662 7.10126 11.0203 6.93622 10.9403C6.89734 10.9215 6.86207 10.896 6.83201 10.865L5.10134 9.07793L5.03733 9.01858C4.72728 8.76087 4.26634 8.77292 3.97012 9.05981C3.65273 9.36718 3.64462 9.87365 3.95199 10.191L5.68266 11.9781L5.78218 12.0739C5.91913 12.1967 6.07281 12.2999 6.23882 12.3803C7.2175 12.8543 8.3951 12.4452 8.86908 11.4665L12.2193 4.54888L12.2512 4.47347Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
